<div class="invitationRegisterComponent">
    <div class="row">
        <div class="col-4 col-pr-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 offset-md-2">
            <div class="image">
                <img id=creditCardSuccess class="img" src="assets/images/Group 2-1.svg" alt="creditCardSuccess" />
            </div>
            <h1 id="title" class="title">{{ copyService.getParametrizedCopy('invitation_register_title', [documentInfo.firstname]) }}</h1>
            <h2 id="subTitle" class="subTitle">{{ copyService.copies.invitation_register_sub_title }}</h2>
            <ol type="1">
                <li id="step">{{ copyService.copies.invitation_register_step_one }}<strong>{{ copyService.copies.invitation_register_step_one_strong }}</strong></li>
                <li id="step">{{ copyService.copies.invitation_register_step_two }}</li>
                <li id="step">
                    {{ copyService.copies.invitation_register_step_three }}
                    <vcl-link [linkId]="'invitationLink'" (click)="goToLink()" [label]="copyService.copies.invitation_register_step_three_link">
                    </vcl-link>
                    {{ copyService.copies.invitation_register_step_three_next }}
                </li>
            </ol>
        </div>
    </div>
</div>
<app-controls id="invitationRegisterCreationBtns" [nextLabel]="copyService.copies.successful_credit_card_creation_control_button" [nextDisabled]="false" (next)="next()"></app-controls>